import React, { useMemo } from 'react';
import { FinalImage } from './images/final-image';
import { ProtagonismImage } from './images/protagonism-image';
import { RecommendationsImage } from './images/recommendations-image';
import { VirtualPartnerImage } from './images/virtual-partner-image';
import { WelcomeImage } from './images/welcome-image';
import './styles.scss';

export type ImageName = 'welcome' | 'protagonism' | 'recommendations' | 'virtualPartner' | 'final';

const images = {
    welcome: WelcomeImage,
    final: FinalImage,
    protagonism: ProtagonismImage,
    virtualPartner: VirtualPartnerImage,
    recommendations: RecommendationsImage,
};

interface OnboardingWhiteLabelItemProps {
    imageName: ImageName;
    title: string;
    description: string;
}
const OnboardingWhiteLabelItem: React.FC<OnboardingWhiteLabelItemProps> = ({ description, imageName, title }: OnboardingWhiteLabelItemProps) => {
    const Image = useMemo(() => images[imageName], [imageName]);
    return (
        <div className="onboarding-whitelabel-item">
            <div className="image">
                <Image />
            </div>

            <h6>{title}</h6>

            <span>{description}</span>
        </div>
    );
};

export { OnboardingWhiteLabelItem };
